exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-contributor-details-jsx": () => import("./../../../src/templates/contributor-details.jsx" /* webpackChunkName: "component---src-templates-contributor-details-jsx" */)
}

